// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_9K7","cls2":"common-cls2_EDu common-cls1_9K7"};